import React, {useDebugValue} from 'react';
import axios from "axios";
import Form from './form';
import Analyze from './analyze';
import {API_URL} from '../env';

const {useState, useEffect} = React;

const Requirement = props => {
    const [resumeData, setResumeData] = useState({})
    const [resumeFetched, setResumeFetched] = useState(false)
    const [requirement, setRequirement] = useState('')
    const [responseLoading, setResponseLoading] = useState(true)
    const [disable, setDisable] = useState(true)
    const [fetchRequirement, setFetchRequirement] = useState({})
    const handleSubmit = () => {
        setResponseLoading(true)
        setResumeFetched(true)
        const url = `${API_URL.url}/requirement`
        axios.post(url, {textInput: requirement, upload: 'false'})
            .then(res => {
                setResumeData({resumeData: res.data})
                setResponseLoading(false)
            }).catch((error) => {
            throw error;
        })
    }

    const fetchSampleRequirement = () => {
        const url = `${API_URL.url}/fetchSampleRequirements`
        axios.get(url)
            .then(res => {
                setFetchRequirement(res.data)
            }).catch((error) => {
            throw error;
        })
    }

    const handleChange = (item) => {
        if(item.target){
            setRequirement(item.target.value)
        } else{
            setRequirement(item)
        }
    }

    useEffect(() => {
        handleDisable();
        if (responseLoading){
            window.scrollTo(0, document.querySelector(".requirement").scrollHeight);
        }
        if (window.location.href.indexOf("matchmaking") > -1) {
            setResumeFetched(true)
        }
    })

    useEffect(() => {
        fetchSampleRequirement();
    },[])

    const handleDisable = () => {
        if (requirement !== '') {
            setDisable(false);
        }
    }

    return (
        <div className='requirement'>
            {
                window.location.href.indexOf("matchmaking") > -1 ? null :
                <Form handleSubmit={handleSubmit} sampleRequirement={fetchRequirement}
                handleChange={handleChange} disable={disable} requirement={requirement}/>
            }
            {
                resumeFetched ? <Analyze data={resumeData} loading={responseLoading}/> : null
            }
        </div>
    )
}

export default Requirement;